module.exports = __webpack_public_path__ + "static/img/logo-fill.ed1daf9d.png";